import React, { FC } from 'react';
import { ICalendlyScoutProps, ICalendlyEvent } from '../types';
import { calendarSharedStyles } from '../../calendarStyles';
import useStyles from '../AddToCalendlyEventModal/useStyles';
import EventType from '../Modal/components/Steps/Step2/EventType';
import { CalendlyAccountDetails } from './calendlyAccountDetails';

interface CalendlyDetailsProps {
  calendlyAccount: ICalendlyScoutProps;
  events: ICalendlyEvent[];
  selectedEvent: ICalendlyEvent | null;
  setSelectedEvent: (event: ICalendlyEvent) => void;
}

export const CalendlyDetails: FC<CalendlyDetailsProps> = ({
  calendlyAccount,
  events,
  selectedEvent,
  setSelectedEvent
}) => {
  const classes = useStyles();
  const sharedCalendarClasses = calendarSharedStyles();

  return (
    <>
      <CalendlyAccountDetails calendlyAccount={calendlyAccount} linkId="calendly-scheduling-url" />
      <div
        className={`${sharedCalendarClasses.meetingContainer} ${
          events.length > 3 ? classes.shadow : ''
        }`}
      >
        {events.length ? (
          events.map((event) => (
            <EventType
              key={event.uri}
              event={event}
              setSelectedEvent={setSelectedEvent}
              selected={selectedEvent?.uri === event.uri}
            />
          ))
        ) : (
          <span className={classes.noEvents}>No available events</span>
        )}
      </div>
    </>
  );
};
